import { Routes } from '@angular/router';

/**
 * Same top-level paths as legacy web-platform-rt (auth, picking, security, monitoring, withdraws kiosk and
 * mobile, queue-manager).
 * The queue manager carries its store in the URL instead of legacy localStorage `queue_manager_*`.
 */
export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'picking',
    loadChildren: () => import('@features/picker/picker.routes').then((m) => m.PICKER_ROUTES),
  },
  {
    path: 'security',
    loadChildren: () => import('@features/security/security.routes').then((m) => m.SECURITY_ROUTES),
  },
  {
    path: 'monitoring',
    loadChildren: () => import('@features/monitoring/monitoring.routes').then((m) => m.MONITORING_ROUTES),
  },
  {
    path: 'withdraws/mobile/:tenantId/:storeCode',
    loadChildren: () => import('@features/customer/customer.routes').then((m) => m.CUSTOMER_ROUTES),
  },
  {
    path: 'withdraws/:tenantId/:storeCode',
    loadChildren: () => import('@features/customer/customer.routes').then((m) => m.CUSTOMER_ROUTES),
  },
  {
    path: 'queue-manager/:tenantId/:storeCode',
    loadChildren: () => import('@features/queue-store/queue-store.routes').then((m) => m.QUEUE_STORE_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'auth/not-found',
  },
];
